import { z } from 'zod';

const partnerObjectSchema = z.object({
  partnerName: z.string(),
  partnerWorkers: z.array(
    z.object({
      firstName: z.string(),
      infix: z.string().nullable(),
      lastName: z.string(),
      workerId: z.string(),
    })
  ),
});

export const preferredWorkerOptionsSchema = z.array(partnerObjectSchema);

export type PreferredWorkerOptions = z.infer<typeof preferredWorkerOptionsSchema>;
